import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div(({ theme }) => ({
  marginTop: 20,
  '& a': {
    color: theme.color.info
  }
}));

const RacingCruncherRules = () => (
  <Wrapper className="content">
    <h2>How does the combo calculator work?</h2>
    <p>
      The Racing Combo Calculator is a free tool which allows you to create multiple lineups from a
      group of horses selected by you.
    </p>
    <p>
      As an example, there are 3 races (legs) and you select the following horse numbers in each
      leg:
    </p>
    <ul>
      <li>Leg 1 - #1, #2</li>
      <li>Leg 2 - #4, #5</li>
      <li>Leg 3 - #7</li>
    </ul>
    <p>
      In the above scenario there would be 4 possible combinations. The combinations are determined
      by multiplying the number of selections in each leg i.e 2 (Leg 1) x 2 (Leg 2) x 1 (Leg 3).
    </p>
    <p>
      By clicking Calculate you produce 4 individual lineups covering all the possible combinations.
    </p>
    <p>The resulting individual lineups would be:</p>
    <ul>
      <li>#1 (L1) - #4 (L2) - #7 (L3)</li>
      <li>#1 (L1) - #5 (L2) - #7 (L3)</li>
      <li>#2 (L1) - #4 (L2) - #7 (L3)</li>
      <li>#2 (L1) - #5 (L2) - #7 (L3)</li>
    </ul>
    <p>
      When the individual lineups have been displayed you can save directly into My Teams. Desktop
      has another option where you can download your lineups as a CSV file and upload in the My
      Teams section at a later time.
    </p>
  </Wrapper>
);

export default RacingCruncherRules;
